import axiosInstance from "./axiosInstance";
import axios, { AxiosError } from 'axios'; 


export const fetchUsers = async () => {
  const response = await axiosInstance.get("/admin/users");
  return response.data;
};

export const createUser = async (
  users: { email: string; endDate: string }[]
) => {
  const response = await axiosInstance.post("/admin/create/users", users);
  console.log(response.data)
  return response.data;
};

export const deleteUser = async (email: string) => {
  await axiosInstance.delete(`/admin/user?email=${email}`);
};

export const updateUserEndDate = async (email: string, endDate: string) => {
  const response = await axiosInstance.patch(`/admin/update/user-etime`, null, {
    params: { email, etime: endDate },
  });
  return response.data;
};

export const updatePassword = async (email: string, password: string) => {
  

  const body = {
    email: email,
    password: password
  };

  try {
    const response = await axiosInstance.patch(`/auth/update/password`, body);
    
    console.log(response.data);

    return "Password updated successfully";
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Error response:", error.response?.data);
      return error.response?.data || "An error occurred while updating the password";
    } else {
      console.error("Unexpected error:", error);
      return "An unexpected error occurred";
    }
  }
};

